import React from 'react'
import { Link } from 'react-router-dom'

export default function PaymentCounter() {
    return (
        <section className="payment-counter payment-counter-bg ptb-120">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 order-last order-md-first">
                        <div className="card-shape position-relative">
                            <div className="card-img mt-5 mt-lg-0">
                                <img
                                    src="assets/img/cr-card.png"
                                    className="img-fluid"
                                    alt="card"
                                />
                            </div>
                            <ul className="list-unstyled m-0">
                                <li>
                                    <div className="counter-circle">
                                        <h4 className="text-danger m-0">32k</h4>
                                        <small>Daily Transaction</small>
                                    </div>
                                </li>
                                <li>
                                    <div className="counter-circle">
                                        <h4 className="text-success m-0">2.3K</h4>
                                        <small>Seller</small>
                                    </div>
                                </li>
                                <li>
                                    <div className="counter-circle">
                                        <h4 className="text-warning m-0">12b+</h4>
                                        <small>Success Payment</small>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                        <div className="payment-counter-right">
                            <h2 className="text-black mb-4">Our Solutions</h2>
                            <div className="mb-3">
                                <h5 className="mb-2 h6">Self-Sovereign Identity</h5>
                                <p className="m-0">
                                    An all-in-one eID platform for seamless identity management, authentication, and data-sharing.
                                </p>
                            </div>
                            <div className="mb-3">
                                <h5 className="mb-2 h6">Inspection Management</h5>
                                <p className="m-0">
                                    A comprehensive platform for conducting a thorough overview of your industrial facilities
                                    within a matter of hours or minutes.
                                </p>
                            </div>
                            <div className="mb-3">
                                <h5 className="mb-2 h6">Digital Workplace</h5>
                                <p className="m-0">
                                    A customizable solution to enable remote collaboration and unify communications in a single and secure hub.
                                </p>
                            </div>
                            <Link to="/contact-us" className="btn-gradient-sqr mt-40"> Contact us </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
